import {toast} from 'sonner'
import ToastContent from './components/ToastContent/ToastContent'

interface ShowToastOptions {
    duration?: number
    linkText?: string
    onLinkClick?: () => void
    type?: 'error'
}

export const showToast = (message: string, options?: ShowToastOptions) => {
    toast.custom(() => (
        <ToastContent
            message={message}
            linkText={options?.linkText}
            onLinkClick={options?.onLinkClick}
            type={options?.type}
        />
    ), { duration: options?.duration })
}
